import { useAppUpdate } from "@hooks/useAppUpdate";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that updates the app on routing
 * @constructor
 */
const AppUpdateOnRouting = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { performAppReload } = useAppUpdate();

  useEffect(() => {
    // Check for app update on routing
    performAppReload();
  }, [pathname, performAppReload]);

  return null;
};

export default AppUpdateOnRouting;
